import { render } from "./about-vision.vue?vue&type=template&id=983d6ae4"
import script from "./about-vision.vue?vue&type=script&lang=js"
export * from "./about-vision.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__